import {
  Button,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import React, { useCallback, useContext, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppsIcon from "@mui/icons-material/Apps";
import { StyledAppBar, StyledToolbar } from "../modules/SiteBuilderElements";
import AssetManager from "../modules/AssetManager";
import { useState } from "react";
import { useParams } from "react-router-dom";
import DeployStagingModal from "./DeployStagingModal";
import DeployProductionModal from "./DeployProductionModal";
import { CustomizerContext } from "../context/CustomizerContext";

const iconButtonStyle = { mr: 2 }
const flexGrowStyle = { flexGrow: 1 }

const SiteBuilderBar = ({ selectedVersion }) => {
  const { documentReady } = useContext(CustomizerContext);
  const [showProductionDeployModal, setShowProductionDeployModal] = useState(false);
  const [showStagingDeployModal, setShowStagingDeployModal] = useState(false);
  const sites = useSelector((state) => state.sites);
  const params = useParams();
  const dispatch = useDispatch();
  const currentSite = useSelector((state) => state.site);

  const site_id = useMemo(() => params.site_id, [params.site_id]);

  const toggleStagingDeployModal = useCallback(() => {
    setShowStagingDeployModal(!showStagingDeployModal);
  }, [showStagingDeployModal]);

  const toggleProductionDeployModal = useCallback(() => {
    setShowProductionDeployModal(!showProductionDeployModal);
  }, [showProductionDeployModal]);

  const handleSwitch = useCallback(() => {
    dispatch({ type: "show-switch-site", open: true });
  }, [dispatch]);

  useEffect(() => {
    if (site_id && sites) {
      const site = sites.find((site) => +site.site_id === +site_id);
      if (site) dispatch({ type: "select-site", site: site });
    }
  }, [sites, site_id, dispatch]);

  const handleOpenAssetModal = useCallback(
    () =>
      dispatch({
        type: "open-assets",
        data: { isOpen: true, showSelection: false },
      }),
    [dispatch]
  );

  return (
    <>
      <StyledAppBar>
        <StyledToolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={iconButtonStyle}
            onClick={handleSwitch}
          >
            <AppsIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={flexGrowStyle}>
            Site Builder {currentSite && ` - ${currentSite.name}`}
          </Typography>
          {documentReady && currentSite && (
            <Stack direction="row" spacing={2}>
              <Button
                onClick={handleOpenAssetModal}
                size="small"
                variant="contained"
                color="warning"
              >
                Assets Collector
              </Button>
              <Button
                onClick={toggleStagingDeployModal}
                size="small"
                variant="contained"
                color="success"
              >
                Deploy Staging
              </Button>
              {currentSite?.domain && (
                <Button
                  onClick={toggleProductionDeployModal}
                  size="small"
                  variant="contained"
                  color="primary"
                >
                  Deploy Production
                </Button>
              )}
            </Stack>
          )}
        </StyledToolbar>
      </StyledAppBar>
      {documentReady &&
        <>
          <DeployStagingModal
            isOpen={showStagingDeployModal}
            onClose={toggleStagingDeployModal}
            selectedVersion={selectedVersion}
            currentSite={currentSite}
          />
          <DeployProductionModal
            isOpen={showProductionDeployModal}
            onClose={toggleProductionDeployModal}
            currentSite={currentSite}
          />
          <AssetManager />
        </>
      }
    </>
  )
}


export default SiteBuilderBar
